import script from "./winItem.vue?vue&type=script&setup=true&lang=js"
export * from "./winItem.vue?vue&type=script&setup=true&lang=js"

import "./winItem.vue?vue&type=style&index=0&id=3c281f14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c281f14"]])

export default __exports__